import { environment } from "src/environments/environment";

export class Companies {

  static companies = [
    {
      "businessName": "TECLOGI",
      "commonName": "TECLOGI",
      "nit": "9013312320"
    },
    {
      "businessName": "BULKMATIC DE COLOMBIA S.A.S",
      "commonName": "BULKMATIC",
      "nit": "9009704395"
    },
    {
      "businessName": "INVERTRAICO S.A.S",
      "commonName": "INVERTRAICO",
      "nit": "9011981505"
    },
    {
      "businessName": "JL & RB S.A.S",
      "commonName": "JL & RB",
      "nit": "9007387182"
    },
    {
      "businessName": "GRUPO NUTRESA",
      "commonName": "GRUPO NUTRESA",
      "nit": "9003410860"
    },
    {
      "businessName": "CARGA PÁRAMO S.A.S",
      "commonName": "CARGA PÁRAMO",
      "nit": "9014171480"
    },
    {
      "businessName": "TRANSPORTE LA ESTRELLA SAS",
      "commonName": "TRANSPORTE LA ESTRELLA",
      "nit": "8000130291"
    },
    {
      "businessName": "SEGURIDAD EXTREMA LTDA",
      "commonName": "SEGURIDAD EXTREMA",
      "nit": "9013522401"
    },
    {
      "businessName": "TRANSALUD",
      "commonName": "TRANSALUD",
      "nit": "9012861321"
    },
    {
      "businessName": "LOGISTICA DE TRANSPORTES CARRILLO PAEZ SAS",
      "commonName": "TRANSPORTES CARRILLO",
      "nit": "9011282346"
    },
    {
      "businessName": "OPPERAR COLOMBIA S.A.S.",
      "commonName": "OPPERAR COLOMBIA",
      "nit": "9007435921"
    },
    {
      "businessName": "GRUPO OPERATIVO LOGISTICA Y TRANSPORTE S.A.S.",
      "commonName": "GRUPO GOLTI SAS",
      "nit": "9016235289"
    },
    {
      "businessName": "HURGO TRANSPORTE Y LOGISTICA SAS",
      "commonName": "HURGO TRANSPORTE",
      "nit": "9009583341"
    },
    {
      "businessName": "VALPA TRANSPORTADORA SAS",
      "commonName": "VALPA TRANSPORTADORA",
      "nit": "9015266765"
    },
    {
      "businessName": "L&H INDUSTRIA ESPECIALIZADA S.A.S.",
      "commonName": "L&H INDUSTRIA ESPECIALIZADA",
      "nit": "9016479769"
    },
    {
      "businessName": "SOLEN GROUP CARGO S.A.S",
      "commonName": "SOLEN GROUP",
      "nit": "9015091787"
    },
    {
      "businessName": "RYF TRANSPORTES Y SERVICIOS S.A.S",
      "commonName": "RYF TRANSPORTES Y SERVICIOS",
      "nit": "9015152615"
    },
    {
      "businessName": "RYF TRANSPORTES Y SERVICIOS CG SAS",
      "commonName": "RYF TRANSPORTES Y SERVICIOS CG",
      "nit": "9019568157"
    }
  ];

  static companiesWithDisabledRegistration = [
    "8000130291"
  ];

  static companiesNIT = {
    LOGGIAPP: "default",
    TECLOGI: "9013312320",
    BULKMATIC: "9009704395",
    INVERTRAICO: "9011981505",
    JL_RB: "9007387182",
    NUTRESA: "9003410860",
    PARAMO: "9014171480",
    LA_ESTRELLA: "8000130291",
    SEGURIDAD_EXTREMA: "9013522401",
    TRANSALUD: "9012861321",
    TRANSPORTES_CARRILLO: "9011282346",
    OPPERAR_COLOMBIA: "9007435921",
    GRUPO_GOLTI: "9016235289",
    HURGO_TRANSPORTE: "9009583341",
    VALPA_TRANSPORTADORA: "9015266765",
    L_H_INDUSTRIA_ESPECIALIZADA: "9016479769",
    SOLEN_GROUP: "9015091787",
    R_Y_F: "9015152615",
    R_Y_F_CG: "9019568157"
  };

  static analyticsAccess = (clientNit: string, saasNit: string) => {
    //Si se indica que lo incluye saasNit está disponible para esa SaaS y sus clientes
    //Si se indica que lo incluye clientNit está disponible solo para la SaaS, no sus clientes.
    return {
      analyticsOperations: [
        Companies.companiesNIT.TECLOGI,
        Companies.companiesNIT.BULKMATIC,
        Companies.companiesNIT.INVERTRAICO,
        Companies.companiesNIT.SEGURIDAD_EXTREMA,
        Companies.companiesNIT.LA_ESTRELLA,
        Companies.companiesNIT.TRANSPORTES_CARRILLO,
        Companies.companiesNIT.OPPERAR_COLOMBIA,
        Companies.companiesNIT.VALPA_TRANSPORTADORA,
        Companies.companiesNIT.HURGO_TRANSPORTE,
        Companies.companiesNIT.GRUPO_GOLTI,
        Companies.companiesNIT.L_H_INDUSTRIA_ESPECIALIZADA,
        Companies.companiesNIT.SOLEN_GROUP,
        Companies.companiesNIT.R_Y_F,
        Companies.companiesNIT.R_Y_F_CG
      ].includes(saasNit),
      vehicleAnalytics: [Companies.companiesNIT.TECLOGI].includes(clientNit),
      dispatch: [Companies.companiesNIT.TECLOGI].includes(clientNit),
      frequentRoutes: [Companies.companiesNIT.TECLOGI, Companies.companiesNIT.BULKMATIC, Companies.companiesNIT.INVERTRAICO].includes(saasNit),
      stopedCargos: [Companies.companiesNIT.TECLOGI, Companies.companiesNIT.BULKMATIC].includes(saasNit),
      analyticsBilling: [Companies.companiesNIT.TECLOGI, Companies.companiesNIT.BULKMATIC].includes(clientNit),
      operationITR: [Companies.companiesNIT.TECLOGI, Companies.companiesNIT.BULKMATIC].includes(clientNit),
      historicalKPI: [Companies.companiesNIT.TECLOGI, Companies.companiesNIT.BULKMATIC].includes(saasNit),
      paymentsDashboard: [Companies.companiesNIT.TECLOGI, Companies.companiesNIT.LA_ESTRELLA].includes(clientNit),
      comercialTurn: [Companies.companiesNIT.TECLOGI].includes(clientNit),
      vehiclesOwnFleet: [
        Companies.companiesNIT.TECLOGI,
        Companies.companiesNIT.LA_ESTRELLA,
        Companies.companiesNIT.GRUPO_GOLTI,
        Companies.companiesNIT.R_Y_F_CG
      ].includes(clientNit),
      historicalDocuments: [
        Companies.companiesNIT.TECLOGI,
        Companies.companiesNIT.BULKMATIC
      ].includes(clientNit),
      profitabilityAnalysis: [
        Companies.companiesNIT.TECLOGI,
        Companies.companiesNIT.INVERTRAICO
      ].includes(clientNit),
      sicetac: [
        Companies.companiesNIT.TECLOGI,
        Companies.companiesNIT.BULKMATIC,
        Companies.companiesNIT.INVERTRAICO,
        Companies.companiesNIT.LA_ESTRELLA,
        Companies.companiesNIT.TRANSPORTES_CARRILLO,
        Companies.companiesNIT.OPPERAR_COLOMBIA,
        Companies.companiesNIT.HURGO_TRANSPORTE,
        Companies.companiesNIT.GRUPO_GOLTI,
        Companies.companiesNIT.VALPA_TRANSPORTADORA,
        Companies.companiesNIT.L_H_INDUSTRIA_ESPECIALIZADA,
        Companies.companiesNIT.SOLEN_GROUP,
        Companies.companiesNIT.R_Y_F,
        Companies.companiesNIT.R_Y_F_CG
      ].includes(clientNit),
      operationsTurn: [
        Companies.companiesNIT.TECLOGI,
        Companies.companiesNIT.BULKMATIC,
        Companies.companiesNIT.INVERTRAICO,
        Companies.companiesNIT.SEGURIDAD_EXTREMA,
        Companies.companiesNIT.LA_ESTRELLA,
        Companies.companiesNIT.TRANSPORTES_CARRILLO,
        Companies.companiesNIT.OPPERAR_COLOMBIA,
        Companies.companiesNIT.VALPA_TRANSPORTADORA,
        Companies.companiesNIT.HURGO_TRANSPORTE,
        Companies.companiesNIT.GRUPO_GOLTI,
        Companies.companiesNIT.L_H_INDUSTRIA_ESPECIALIZADA,
        Companies.companiesNIT.SOLEN_GROUP,
        Companies.companiesNIT.R_Y_F,
        Companies.companiesNIT.R_Y_F_CG
      ].includes(clientNit),
      lostSales: [Companies.companiesNIT.TECLOGI].includes(clientNit),
      reportUIAF: Object.values(Companies.companiesNIT).filter(nit => nit !== Companies.companiesNIT.LOGGIAPP).includes(clientNit),
      fulfillments: [Companies.companiesNIT.TECLOGI].includes(clientNit),
      fulfillmentsClients: [Companies.companiesNIT.TECLOGI].includes(saasNit),
    };
  }

  static onlyTransportServicesPermissions = [
    '/administration/adminTrailers',
    '/administration/changeFeeToOwnedFleet',
    '/administration/modifyAdditionalCostBilled',
    '/administration/deleteAdditionalServicesBilled',
    '/administration/deleteAdditionalServicesApproved',
    '/administration/modifyAdditionalCostpayed',
    '/administration/addAdditionalServiceCargoPaid',
    '/administration/addAdditionalServiceCargoCashed',
    '/administration/addAdditionalServiceCargoApproved',
    '/cargo/documentManifest',
    '/cargo/cancelManifest',
    '/cargo/documentManifestUrban',
    '/cargo/documentConsignment',
    '/cargo/documentConsignmentUrban',
    '/cargo/readManifest',
    '/cargo/viewRndcFulfillManifestConsignmentHistory',
    '/cargo/additionalCosts',
    '/cargo/additionalCostCreate',
    '/cargo/additionalCostUpdate',
    '/cargo/additionalCostDelete',
    '/cargo/confirmationAdditionalMandatoryServices',
    '/cargo/uploadExternalManifest',
    '/cargo/createCargoFromRoute',
    '/cargo/createMassiveCargo',
    '/cargo/createCargoByGuides',
    '/cargo/createManualCargo',
    '/cargo/showManifestError',
    '/cargo/editWeightConsignment',
    '/cargo/editCargoAmount',
    '/cargo/editRiskProfile',
    '/cargo/specialLicensePlate',
    '/cargo/createCargosWithoutMinimumUtility',
    '/cargo/approvedBelowSicetac',
    '/cargo/showEditServiceNegotiationModule',
    '/cargo/showEditRequestNegotiationModule',
    '/cargo/createService',
    '/cargo/createServicesWithExpiredPolicy',
    '/cargo/automaticTotalCostCalculation',
    '/cargo/createCargoRequest',
    '/cargo/changeManifestRequirement',
    '/cargo/cargoRequestNegotiation',
    '/cargo/createRequestFromManualCreationCargo',
    // El cambio de transportadora anula y recrea documentos RNDC, así que no
    // aplica a una SaaS sin servicios de transporte.
    '/cargo/changeTransportCompany',
    '/cargo/serviceRequests',
    '/cargo/createTransportRequests',
    '/cargo/panelAssignments',
    '/cargo/changeDispatchState',
    '/cargo/viewHistoryDispatchStateChanges',
    '/cargo/createApplications',
    '/cargo/editApplications',
    '/cargo/approveBonusFromApplication',
    '/cargo/generateManifest',
    '/setting/termsManifest',
    '/payments/approvePaymentsWithTravelExpensesPending',
    '/payments/paymentAdditionalCosts',
    '/administration/changeFleetLoyalty',
    '/administration/changeVehicleFleetLoyalty',
    '/cargo/editConsignment',
    '/cargo/generateNewConsignment',
    '/cargo/deleteConsignment',
    '/cargo/assignUnassignCostCenterToService',
    '/cargo/showConsignmentServiceModule',
    '/cargo/editConsignmentServiceModule',
    '/cargo/editPublicationZone',
    '/cargo/linkServices',
    '/cargo/unlinkServices',
    '/cargo/viewLogisticTimes',
    '/cargo/editLogisticTimes',
    '/guide/guideList',
    '/guide/trackGuide',
    '/guide/addNoveltyToGuide',
    '/guide/editGuideNovelties',
    '/guide/editUseEvidenceToGuides',
    '/administration/editAdditionalServicesUtilities',
    '/payments/fulFillCargosRndc',
  ];
  static onlyOwnFleetAndTeclogiPermissions = [
    '/cargo/additionalServicesWithoutUtilityRestriction',
  ];
  static escortServicesPermissions = [
    '/cargo/createEscortService',
    '/administration/useGpsPortable',
    '/administration/alertValidGps',
  ];
  static satelliteLockServicesPermissions = [
    '/cargo/createSatelliteLockService',
    '/administration/adminSatelliteLock',
    '/administration/updateSatelliteLock',
    '/administration/createSatelliteLock',
    '/administration/deleteSatelliteLock',
    '/administration/assignSatelliteLock',
    '/cargo/editSatelliteLockModule',
  ]
  static onlyTeclogiPermissions = [
    '/setting/quickPay',
    '/administration/requestValidation',
  ];

  static hiddenPermissions = [
    "/help-desk/listTicket",
    "/help-desk/createTicket",
    "/helpDesk/replyTechnicalTicket",
    "/helpDesk/replyWebTicket",
    "/helpDesk/replyMobileTicket",
    "/helpDesk/replyOtherTicket",
    "/helpDesk/reopenTicket",
  ];

  static rndcPermissions = [
    "/cargo/viewRndc",
    "/cargo/rndcFulfillments",
    "/rndc/viewRndcStatus",
  ];


  static companiesAccess(route: string, clientNit: string, saasNit: string): boolean {
    if (route && this.hiddenPermissions.includes(route))
      return false;
    if (!environment.production) return true;
    if (route && route.includes('/analytics/'))
      return !!this.analyticsAccess(clientNit, saasNit)[route.split("/analytics/")[1]];
    if (route && this.onlyTransportServicesPermissions.includes(route))
      return ![this.companiesNIT.SEGURIDAD_EXTREMA].includes(saasNit);
    if (route && this.onlyOwnFleetAndTeclogiPermissions.includes(route))
      return [this.companiesNIT.LA_ESTRELLA, this.companiesNIT.TECLOGI].includes(clientNit);
    if (route && this.escortServicesPermissions.includes(route))
      return [this.companiesNIT.SEGURIDAD_EXTREMA].includes(saasNit);
    if (route && this.satelliteLockServicesPermissions.includes(route))
      return [this.companiesNIT.SEGURIDAD_EXTREMA].includes(saasNit);
    if (route && this.onlyTeclogiPermissions.includes(route))
      return [this.companiesNIT.TECLOGI].includes(clientNit);
    if (route === '/administration/companies/config')
      //Solo usuarios de las empresas SaaS, no sus clientes
      return this.companies.some(company => company.nit === saasNit);
    if (route && this.rndcPermissions.includes(route))
      return ![this.companiesNIT.SEGURIDAD_EXTREMA].includes(saasNit) && clientNit === saasNit;
    return true;
  }

  static permissionAccess(permission: string, clientNit: string, saasNit: string): boolean {
    if (permission && this.hiddenPermissions.some(route => route.split('/')[2] === permission))
      return false;
    if (!environment.production) return true;
    if (permission && permission in this.analyticsAccess(clientNit, saasNit))
      return !!this.analyticsAccess(clientNit, saasNit)[permission];
    if (permission && this.onlyTransportServicesPermissions.some(route => route.split('/')[2] === permission))
      return ![this.companiesNIT.SEGURIDAD_EXTREMA].includes(saasNit);
    if (permission && this.onlyOwnFleetAndTeclogiPermissions.some(route => route.split('/')[2] === permission))
      return [this.companiesNIT.LA_ESTRELLA, this.companiesNIT.TECLOGI].includes(clientNit);
    if (permission && this.escortServicesPermissions.some(route => route.includes(permission)))
      return [this.companiesNIT.SEGURIDAD_EXTREMA].includes(saasNit);
    if (permission && this.satelliteLockServicesPermissions.some(route => route.includes(permission)))
      return [this.companiesNIT.SEGURIDAD_EXTREMA].includes(saasNit);
    if (permission && this.onlyTeclogiPermissions.some(route => route.split('/')[2] === permission))
      return [this.companiesNIT.TECLOGI].includes(clientNit);
    if (permission && this.rndcPermissions.some(route => route.split('/')[2] === permission))
      return ![this.companiesNIT.SEGURIDAD_EXTREMA].includes(saasNit) && clientNit === saasNit;
    return true;
  }

  static modulesAccess(module: string, clientNit: string, saasNit: string): boolean {
    if (!environment.production) return true;
    switch (module) {
      case 'point':
        return false;
      case 'routing':
      case 'rndc':
        //Empresas SaaS que no tengan servicios de escolta
        return ![this.companiesNIT.SEGURIDAD_EXTREMA].includes(saasNit);
      default:
        return true;
    }
  }
}
